import API from '../api/api';
import { ApiRoutes } from '../constans/api';

const VITE_APP_API_KEY = import.meta.env.VITE_APP_API_KEY ?? '';

export interface IResetPassLinkRequest {
  email: string;
}

const headers = {
  'x-api-key': VITE_APP_API_KEY as string,
};

export const resetPassLinkRequest = async (email: IResetPassLinkRequest) => {
  const { passwordReset } = ApiRoutes;
  const { data } = await API.post(passwordReset, email, {
    headers: headers,
  });
  return data;
};

export interface IValidateTokenRequest {
  token: string;
}

export const validateTokenRequest = async (token: IValidateTokenRequest) => {
  const { passwordResetValidateToken } = ApiRoutes;
  const { data } = await API.post(passwordResetValidateToken, token, {
    headers: headers,
  });
  return data;
};

export interface IConfirmResetPassRequest {
  token: string;
  password: string;
}

export const confirmResetPasswordRequest = async (credentials: IConfirmResetPassRequest) => {
  const { passwordResetConfirm } = ApiRoutes;
  const { data } = await API.post(passwordResetConfirm, credentials, {
    headers: headers,
  });
  return data;
};
